import React from 'react';

function NotFound() {
    return (
        <React.Fragment>
            <main className="app-page">
                <section className="app-page-content">
                    <div className="app-empty-state">
                        Sorry -- I couldn't find that page
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default NotFound;
